import XButton from './XButton';
import { deleteBtnClasses } from './listItemClasses';
import { spinnerClasses } from './loaderClasses';

const FileButtonOptions = ({ divClassName = "", iconClassName = "", onDownload, onDelete, isLoading, isDeleteDisabled = false, hideDelete = false }) => {
  return (
    <div className={divClassName}>
      {isLoading ? <span className={spinnerClasses} role="status" aria-label="Loading" /> : <>
        <XButton
          variant="close"
          onClick={onDownload}
          aria-label="Download file"
          className={iconClassName ? `${iconClassName} mr-2` : `${deleteBtnClasses} mr-2`}
        >
          <i className="fas fa-download"></i>
        </XButton>
        {!hideDelete && (
          <XButton
            variant="close"
            onClick={onDelete}
            disabled={isDeleteDisabled}
            aria-label="Delete file"
            className={iconClassName ? `${iconClassName} mr-12` : `${deleteBtnClasses} mr-2`}
          >
            <i className="fas fa-trash-alt"></i>
          </XButton>
        )}
      </>}
    </div>
  );
};

export default FileButtonOptions;
